<template>
  <div>
    <div align="right">
      <el-button type="primary" size="mini" @click="dialogVisible = true">
        Create Brand
      </el-button>
    </div>
    <el-dialog title="Create Brand" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
        <el-form-item label="Brand name" prop="name">
          <el-input v-model="form.name" placeholder="Enter brand name"></el-input>
        </el-form-item>
        <el-form-item label="Country of Origin" prop="country_id">
          <app-countries v-model="form.country_id" />
        </el-form-item>
        <el-form-item label="Description in up to 500 characters" prop="desc">
          <el-input v-model="form.desc" placeholder="Enter brand description" type="textarea" rows="5"></el-input>
        </el-form-item>
        <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
        <el-button @click="onCancel('form')">Cancel</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import AppCountries from '@/components/App/AppCountries'

export default {
  components: {
    AppCountries,
  },

  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        name: null,
        country_id: null,
        desc: null,
      },
      rules: {
        'name': [
          { required: true, message: 'Enter brand name.', trigger: 'blur' },
        ],
        'country_id': [
          { required: true, message: 'Select your country.', trigger: 'blur' },
        ],
        'desc': [
          { required: true, message: 'Enter brand description.', trigger: 'blur' },
          { min: 140, max: 500, message: 'Length should be 140 to 280.', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.post(`/brands`, {
            country_id: this.form.country_id,
            name: this.form.name,
            desc: this.form.desc,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$router.push({ name: 'brands-id', params: { id: data.brand.id } })
        this.$message.success(data.message)
      })
    },

    onCancel(form) {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
}
</script>
